export default __webpack_public_path__ + "static/ponkes-1-4a7df139a3a8eb1d84fdb9ded8586716.jpg";